module.exports = __webpack_public_path__ + "static/media/more-dots.e623c29a.svg";